import { render } from "./IsoVoyageImage.vue?vue&type=template&id=26a2117b"
import script from "./IsoVoyageImage.vue?vue&type=script&lang=js"
export * from "./IsoVoyageImage.vue?vue&type=script&lang=js"

import "./IsoVoyageImage.vue?vue&type=style&index=0&id=26a2117b&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__